module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    staticClass: "sound-selector",
    on: {
      "change": function($event) {
        return _vm.loadSound()
      }
    }
  }, [_c('legend', [_vm._v("Sound Selector")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sound),
      expression: "sound"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sound = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.families), function(f) {
    return _c('optgroup', {
      attrs: {
        "label": f.name
      }
    }, _vm._l((_vm.filteredSounds(f.id)), function(sound) {
      return _c('option', {
        domProps: {
          "value": sound.value
        }
      }, [_vm._v(_vm._s(sound.name))])
    }), 0)
  }), 0), _vm._v(" "), (_vm.canShowFileInput) ? _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileOpen
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canShowRecorder) ? _c('recorder') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a5ea14c0!./src/components/sound-selector/sound-selector.html
// module id = 116
// module chunks = 2